export default "__VITE_ASSET__44bedbfa__"